export default "__VITE_PUBLIC_ASSET__af430214__"